import React from "react";
import { useBuilder, BlockConfig } from "../BuilderContext";

const formatPA = (pa: string) =>
  pa.split("_").map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");

const MatterDetailsBlock: React.FC<{ block: BlockConfig }> = ({ block }) => {
  const { state } = useBuilder();
  const heading = block.settings.headingOverride || "Matter Details";
  const matter = state.matter;
  if (!matter) return null;

  return (
    <div className="py-4">
      <p className="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-2">{heading}</p>
      <div className="grid grid-cols-3 gap-4 text-sm">
        <div>
          <p className="text-xs text-slate-400">Matter/File #</p>
          <p className="font-medium text-slate-800">{matter.matterNumber}</p>
        </div>
        <div>
          <p className="text-xs text-slate-400">Matter</p>
          <p className="font-medium text-slate-800">{matter.title}</p>
        </div>
        {matter.practiceAreas?.length > 0 && (
          <div>
            <p className="text-xs text-slate-400">Practice Area</p>
            <p className="font-medium text-slate-800">{matter.practiceAreas.map(formatPA).join(", ")}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MatterDetailsBlock;
